// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__hPOOl","selected":"Chip_selected__1pZlI"};